const typeList = {
    input: 'Achat',
    output: 'Vente'
} as any
export default typeList;
